import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const How2Install = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h3>{t('explore.install.title')}</h3>
      <p dangerouslySetInnerHTML={{ __html: t('explore.install.text') }} />

      <h3 className="mt-5">Download Youfy Agent</h3>
      <ul className="list-group">
        <li className="list-group-item">
          <a href="https://s3.amazonaws.com/download.youfy.com.br/agent/Youfy+Agent.exe" target="_blank" rel="noreferrer">
            Windows 10 ou superior - 64 bits
          </a>
        </li>
        <li className="list-group-item">
          <a href="https://s3.amazonaws.com/download.youfy.com.br/agent/Youfy+Agent.AppImage" target="_blank" rel="noreferrer">
            Linux Ubuntu 18.04 ou superior - 64 bits
          </a>
        </li>
        <li className="list-group-item">
          <a href="https://s3.amazonaws.com/download.youfy.com.br/agent/Youfy+Agent.dmg" target="_blank" rel="noreferrer">
            MacOS Catalina ou superior
          </a>
        </li>
      </ul>

      <div className="mt-5">
        Se precisar de ajuda, fale com nosso{' '}
        <Link to="#help" className="purechat-button-expand">
          suporte
        </Link>
        .
      </div>
    </div>
  );
};

export default How2Install;
